import { Dayjs } from 'dayjs';
import { SupportedLanguages, Translation } from 'hooks/useTranslation/useTranslation';
import { upperFirst } from 'lodash';
import { EMPTY_VALUE_PLACEHOLDER } from 'v2/constants';
import { capitalizeFirstChar } from 'v2/utils/string';

export const getTranslatedFormattedDate = (
  date: Dayjs,
  getLanguage: () => SupportedLanguages,
  getLocaleForDayjs: (getLanguage: () => SupportedLanguages) => any
) => {
  const translatedDate = date.locale(getLocaleForDayjs(getLanguage));
  return `${translatedDate.format('D')} ${upperFirst(translatedDate.format('MMM'))} ${translatedDate.format('YYYY')}`;
};

export const getTranslatedReason = (text: string, translation: Translation) => {
  switch (text) {
    case 'No token':
    case 'NO_TOKEN':
      return translation.no_token;
    case 'Unknown':
    case 'DOM_UNKNOWN':
      return translation.unknown;
    case 'Battery issue':
    case 'DOM_BATTERY_ISSUE':
      return translation.battery_issue;
    case 'Set persistent mode':
    case 'DOM_SET_PERSISTENT_MODE':
      return translation.office_mode_on;
    case 'Reset persistent mode':
    case 'DOM_RESET_PERSISTENT_MODE':
      return translation.office_mode_off;
    case 'TOKEN_SEND_TO_LOCK':
      return translation.token_send_to_lock;
    case 'DOM_ACCESS_GRANTED':
    case 'TANLOCK_GRANTED':
      return EMPTY_VALUE_PLACEHOLDER;
    default:
      const textNoUnderscore = text.replaceAll('_', ' ');
      return capitalizeFirstChar(textNoUnderscore);
  }
};
